import React, { Component } from 'react';
import confetti from "canvas-confetti";

class Visita extends Component {
 componentDidMount() {
  window.startx();

  const section = document.querySelector(".cumpleaños");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {

        const duration = 1000;
        const end = Date.now() + duration;

        const frame = () => {
          confetti({
            particleCount: 5,
            angle: 60,
            spread: 80,
            origin: { x: 0 }
          });

          confetti({
            particleCount: 5,
            angle: 120,
            spread: 80,
            origin: { x: 1 }
          });

          if (Date.now() < end) {
            requestAnimationFrame(frame);
          }
        };

        frame();

        observer.disconnect(); // evita que se repita
      }

    });
  }, {
    threshold: 0.4
  });

  if (section) observer.observe(section);

  // PARTICULAS BRILLANTES
const particlesContainer = document.querySelector(".cumpleaños .particles");

if (particlesContainer) {

  for (let i = 0; i < 35; i++) {

    const particle = document.createElement("span");
    particle.classList.add("particle");

    particle.style.left = Math.random() * 100 + "%";
    particle.style.animationDuration = (Math.random() * 6 + 4) + "s";
    particle.style.animationDelay = Math.random() * 5 + "s";

    particlesContainer.appendChild(particle);
  }
}


// GLOBOS FLOTANTES
const balloonsContainer = document.querySelector(".cumpleaños .balloons");

if (balloonsContainer) {

  const colors = ["#ff4d6d","#ffd93d","#6bcBef","#9d4edd","#4cd137"];

  for (let i = 0; i < 10; i++) {

    const balloon = document.createElement("div");
    balloon.classList.add("balloon");

    balloon.style.left = Math.random() * 100 + "%";
    balloon.style.background = colors[Math.floor(Math.random()*colors.length)];
    balloon.style.animationDuration = (Math.random()*10 + 8) + "s";
    balloon.style.animationDelay = Math.random()*5 + "s";

    balloonsContainer.appendChild(balloon);
  }
}
}
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Horarios de Servicio</h2>
          </header>
          <div className="row">
            <div className="grid-item0 justificacion col-9 horarios">
              <div class="row">
                <div class="col-md-4">
                  <img src="images/iconoReloj.png" alt="IconoReloj" />
                </div>
                <div class="col-md-8">
                  <strong>Horario de Museo</strong>
                  <p>Martes a domingo de 9:30 a 18:30 h.</p>
                  <p> </p>
                  <strong>Horario de Dinoparque</strong>
                  <p>De Lunes a Domingo de 9:30 a 18:30 h. </p>
                  <p> </p>
                  <strong>Horario de Taquillas</strong>
                  <p>De Lunes a Domingo de 9:30 a 17:00 h. </p>
                  <p> </p>
                </div>
                <div className="grid-item0 col-md-4 col-sm-6 col-12">
                </div>
              </div>
            </div>
            <div>
              <header className="major">
                <h2>Precios Individuales y Paquetes</h2>
              </header>
              <strong className="center"><h4>Boleto de Niño/a de (2 a 12 años), (INAPAM) y personas con discapacidad.</h4></strong>
              <strong className="center"><h4>Boleto de Adulto a partir de los 13 años.</h4></strong>
              <div className="row paquetes">
                <div className="grid-item0 col-md-4 col-sm-6 <col-12">
                  <strong className="titulo"><p>Museo</p></strong>
                  <p>Niño/a</p>
                  <strong className="precio"><p>$50</p></strong>
                  <p>Adulto</p>
                  <strong className="precio"><p>$59</p></strong>
                </div>
                <div className="grid-item0 col-md-4 col-sm-6 col-12">
                  <strong className="titulo"><p>Planetario</p></strong>
                  <p>Niño/a</p>
                  <strong className="precio"><p>$50</p></strong>
                  <p>Adulto</p>
                  <strong className="precio"><p>$59</p></strong>
                 {/*
                 celdas mas cortas
                  <dl><p>Niño/a</p></dl>
                  <dl><strong className="precio"><p>$49</p></strong></dl>
                  <dl><p>Adulto</p></dl>
                  <dl><strong className="precio"><p>$57</p></strong></dl>
                <a href="/images/FUNCIONES_PLANETARIO.jpg" target="blank" className="button.disabled">Consulta la Cartelera Aquí</a> 
                 */}
                </div>
                <div className="grid-item0 col-md-4 col-sm-6 col-12">
                  <strong className="titulo"><p>Avión Virtual</p></strong>
                  <p>Niño/a</p>
                  <strong className="precio"><p>$22</p></strong>
                  <p>Adultos</p>
                  <strong className="precio"><p>$29</p></strong>
                </div>
                <div className="grid-item0 col-md-4 col-sm-6 col-12">
                  <strong className="titulo"><p>Makerspace</p></strong>
                  <p>Niño/a</p>
                  <strong className="precio"><p>$50</p></strong>
                  <p>Adultos</p>
                  <strong className="precio"><p>$59</p></strong>
                </div>
                <div className="grid-item0 col-md-4 col-sm-6 col-12">
                  <strong className="titulo"><p>Dinoparque</p></strong>
                  <p>Niño/a y adulto</p>
                  <strong className="precio"><p>$50</p></strong>
                  <p>Incluye acceso a: Jardín Botánico y Paseo Arqueológico.</p>
                </div>
                <div className="grid-item0 col-md-4 col-sm-6 col-12">
                  <strong className="titulo"><p>Sala de Realidad Virtual</p></strong>
                  <p>Niño/a y adulto</p>
                  <strong className="precio"><p>$54</p></strong>
                  <p>Incluye acceso a la Sala y uso de dos juegos.</p>
                  <p>*Consulta las especificaciones para el uso de los simuladores.</p>
                </div>
                <div className="grid-item0 col-md-6 col-sm-6 col-12">
                  <strong className="titulo"><p>Paquete 1</p></strong>
                  <strong className="center"><h3>Museo y Dinoparque</h3></strong>
                  <p>Niño/a</p>
                  <strong className="precio"><p>$68</p></strong>
                  <p>Adulto</p>
                  <strong className="precio"><p>$76</p></strong>
                </div>
                <div className="grid-item0 col-md-6 col-sm-6 col-12">
                  <strong className="titulo"><p>Paquete 2</p></strong>
                  <strong className="center"><h3>Museo, Dinoparque y Planetario</h3></strong>
                  <p>Niño/a</p>
                  <strong className="precio"><p>$110</p></strong>
                  <p>Adulto</p>
                  <strong className="precio"><p>$127</p></strong>
                </div>
              </div>
            </div>
            <div class="paquetes1">
              <strong className="center"></strong>
              <div className="row">
                <div className="grid-item0 col-md-6 col-sm-6 col-12">
                </div>
              </div>
            </div>
           <div className="cumpleaños">

  <div className="cumple-bg"></div>
  <div className="particles"></div>
  <div className="balloons"></div>

  <div className="contenidoCumple">

    <div className="imgCumple">
      <img className="sombreroCumpleaños" src="images/sombrero.png" alt="Icono Sombrero" />
    </div>

    <strong className="center">
      <h2>¡CELEBRA TU CUMPLEAÑOS CON NOSOTROS!</h2>
    </strong>

    <div className="container">
      <div className="grid-item0 col-md-12 col-sm-12 col-12">

        <p>Área Reservada máximo 5 hrs.(Ágora de Dinoparque)</p>
        <p>Botarga por 1 hr.</p>
        <p>Máximo 40 personas</p>
        <p>Taller Interactivo <small>(Boligoma o Papiroflexia)</small></p>
        <p>Mesas y Sillas</p>

        <strong><p>Costo: $5,064.56</p></strong>

        <p>Reservaciones:</p>
        <p>Tel.: 7717112044 Ext. 100</p>
        <p>Correo: reservaciones.rehilete@hotmail.com</p>

      </div>
    </div>

  </div>

</div>
          </div>
          <div className="row mapa">
            <h2 className="center"><img class="ubicacion" src="images/ubicacion.png" alt="Ubicacion" />Ubicación</h2>
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14989.452364199213!2d-98.7772342!3d20.0771033!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x805ec5a81b497dae!2sMuseo+El+Rehilete!5e0!3m2!1sen!2smx!4v1554315879329!5m2!1sen!2smx" width="100%" height="350" frameborder="0" style={{ border: 0, marginTop: 50, marginBottom: 50 }} allowfullscreen title="Mapa">
            </iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default Visita;